import { BaseApi } from '.';
export const SolarExamineReportApi = {
  getExamineReportSummary,
  getExamineReportDetail,
  getReportsInSameExamineDate,
  getExamineReport,
  getAllExamineReport,
  getAiAnalysisStatus,
  requestAIAnalysisJob,
  cancelAiAnalysisJob
};

function getReportsInSameExamineDate(reportId) {
  return BaseApi.get(`/examine-report/${reportId}/same-examine-date`);
}

function getExamineReportSummary(reportIds) {
  // reportIds가 배열이면 쿼리 파라미터로 전달, 단일 값이면 배열로 변환
  const reportIdArray = Array.isArray(reportIds) ? reportIds : [reportIds];
  const params = new URLSearchParams();
  reportIdArray.forEach(id => params.append('reportId', id));
  return BaseApi.get(`/examine-report/summary/create?${params.toString()}`);
}

function getExamineReportDetail(reportIds) {
  // reportIds가 배열이면 쿼리 파라미터로 전달, 단일 값이면 배열로 변환
  const reportIdArray = Array.isArray(reportIds) ? reportIds : [reportIds];
  const params = new URLSearchParams();
  reportIdArray.forEach(id => params.append('reportId', id));
  return BaseApi.get(`/examine-report/detail/create?${params.toString()}`);
}

function getExamineReport(reportId) {
  return BaseApi.get(`/solarExamineReports/${reportId}`);
}

function getAllExamineReport() {
  return BaseApi.get('/solarExamineReports');
}

function getAiAnalysisStatus(reportId, axiosConfig) {
  return BaseApi.get(`/ai/status/${reportId}`, axiosConfig);
}

function requestAIAnalysisJob(
  reportId,
  jobKinds = [],
  altCorrectValue,
  isSampling = false,
  aiDetectImageRatio = null,
  heightSource = null,
  axiosConfig
) {
  const params = new URLSearchParams();

  if (isSampling) {
    params.append('sampling', 'y');
  }

  const body = { altCorrectionValue: altCorrectValue || 0 };
  if (aiDetectImageRatio != null && Number.isFinite(Number(aiDetectImageRatio))) {
    body.aiDetectImageRatio = Number(aiDetectImageRatio);
  }
  if (heightSource && ['LRF', 'GPS'].includes(heightSource)) {
    body.heightSource = heightSource;
  }

  if (!Array.isArray(jobKinds) || jobKinds.length === 0) {
    const url = params.toString()
      ? `/ai/start/${reportId}?${params.toString()}`
      : `/ai/start/${reportId}`;
    return BaseApi.post(url, body, axiosConfig);
  }

  jobKinds.forEach(job => params.append('job', job));

  return BaseApi.post(`/ai/start/${reportId}?${params.toString()}`, body, axiosConfig);
}

function cancelAiAnalysisJob(aiJobId, axiosConfig) {
  return BaseApi.post(`/ai/${aiJobId}/cancel`, null, axiosConfig);
}
